import React from 'react';
import { Menu } from 'lucide-react';

const Header = ({ onMenuClick }) => {
    return (
        <header className="bg-white border-b border-slate-200 p-4 flex items-center justify-between md:hidden relative z-10">
            <h1 className="text-lg font-bold text-slate-800">ЛОГО</h1>
            <button onClick={onMenuClick} className="text-slate-600 p-1">
                <Menu size={24} />
            </button>
        </header>
    );
};

export default Header;